import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as types from 'constants/actionTypes';
import { RadioGroup, FormControlLabel, Radio } from '@mui/material';


class RadioInput extends Component {
    constructor(props) {
        super(props);
        // if we have the default value, we will set the initial value to default value,
        // if not we will use Redux State
        // else we will use the first option of the radio group
        if (props.defaultValue || props.defaultValue === "") {
            this.state = { ...this.state, value: props.defaultValue, error: "" };
            this.props.dispatch({ type: types.FORM_INPUT, value: props.defaultValue, name: this.props.groupName });
        } else if (props.value){
            this.state = { ...this.state, value: props.value, error: "" };
        }else{
            this.state = { ...this.state, value: props.options[0].value, error: "" };
            this.props.dispatch({ type: types.FORM_INPUT, value: props.options[0].value, name: this.props.groupName });
        }
    }

    componentWillReceiveProps(newProps) {
        if (newProps.value !== this.state.value) {
            this.setState({ value: newProps.value });
        }

        if (newProps.error && newProps.error !== this.state.error)
            this.setState({ error: newProps.error });
    }

    onChange = (event) => {
        const value = event.target.value;
        this.setState({ value });
        this.props.dispatch({ type: types.FORM_INPUT, value, name: this.props.groupName });
        if (this.props.onChangeCallback) {
            this.props.onChangeCallback(value);
        }
    }

    radioOptions(options) {
        return options.map((option, index) => (
            // <RadioButton
            //     disabled={option.disabled}
            //     key={option.value}
            //     value={option.value}
            //     label={option.text} />


            <FormControlLabel
                id={`radioOption-${index}`}
                key={option.value}
                value={option.value}
                control={<Radio />}
                label={option.label || option.text}
                disabled={option.disabled}
            />
        ));
    }

    render() {
        const p = this.props;
        const e = this.state && this.state.error;
        const value = this.state.value;

        return (
            <div className={`form-group RadioInput ${p.className || ``}`}>
                {p.title && <label>{p.title}{p.required && `*`}</label>}
                <RadioGroup
                    className={`${p.className} radio-group`}
                    name={p.groupName}
                    value={value}
                    onChange={this.onChange}
                >
                    {this.radioOptions(p.options)}
                </RadioGroup>

                {(e && value === undefined) ? <span className="validationMessage">{p.error}</span> : ''}
            </div>
        );
    }
}


const mapStateToProps = (state, props) => {
    return {
        value: state.form[props.groupName],
        error: state.form && state.form.error && state.form.error[props.groupName]
    };
};

export default connect(mapStateToProps)(RadioInput);
